import { AxiosRequestConfig } from "axios";
import localStorageKeys from "src/core/constants/local-storage-keys";
import {v4 as uuidv4} from "uuid";

const requestInteceptor = (config: AxiosRequestConfig) => {
	const id = localStorage.getItem(localStorageKeys.userId); // get user id
	const batchId = localStorage.getItem(localStorageKeys.batchId); // get user id
	if (config.data.variables.user) {
		config.data.variables.user.meta["correlationId"] = uuidv4();
		config.data.variables.user.meta["batchId"] = batchId;
		config.data.variables.user.meta["user"] = id;
	} else if (config.data.variables.transaction) {
		config.data.variables.transaction.meta["correlationId"] = uuidv4();
		config.data.variables.transaction.meta["batchId"] = batchId;
		config.data.variables.transaction.meta["user"] = id;
	} else if (config.data?.variables?.meta) {
		config.data.variables.meta["correlationId"] = uuidv4();
		config.data.variables.meta["batchId"] = batchId;
		config.data.variables.meta["user"] = id;
	} else {
		// console.log(config);
		// config.data.variables
	}
	//   Check if Authorization should be used.
	if (config.headers.requiresToken) {
		const token = localStorage.getItem(localStorageKeys.token); // get toke
		config.headers["Authorization"] = `Bearer ${token}`;
	}
	delete config.headers.requiresToken;
	return config;
};

export default requestInteceptor;
